<template>
  <div ref="builderpage">
    <video-sidebar :isSidebarActive="videoSidebar"
                  :nodeSelected="selectedNode"
                  :buttoncaption="caption"
                  :sidebarHeader="sbarHeader"
                  @saveData="dataSaved"
                  @closeSidebar="videoSidebar = false"
                  :courseId="courseId"
                  :gotoList="allGotos"
                  :moduleId="moduleId"
                  :sourceTaskId="sourceTaskId"
                  :taskTypeList="taskTypeList"
                  :taskClassificationTypes="taskClassificationTypes"
                  :taskGroupId="taskGroupData.id"
                  :styleB="true"
                  :taskNumber ="lastIndex" />

    <document-sidebar :isSidebarActive="documentSidebar"
                      :nodeSelected="selectedNode"
                      :buttoncaption="caption"
                      :sidebarHeader="sbarHeader"
                      @saveData="dataSaved"
                      @closeSidebar="documentSidebar = false"
                      :courseId="courseId"
                      :gotoList="allGotos"
                      :moduleId="moduleId"
                      :sourceTaskId="sourceTaskId"
                      :taskTypeList="taskTypeList"
                      :taskClassificationTypes="taskClassificationTypes"
                      :taskGroupId="taskGroupData.id"
                      :styleB="true"
                      :taskNumber ="lastIndex" />
      
      <upload-sidebar :isSidebarActive="uploadSidebar"
                    :nodeSelected="selectedNode"
                    :buttoncaption="caption"
                    :sidebarHeader="sbarHeader"
                    @saveData="dataSaved"
                    @closeSidebar="uploadSidebar = false"
                    :gotoList="allGotos"
                    :courseId="courseId"
                    :moduleId="moduleId"
                    :sourceTaskId="sourceTaskId"
                    :taskTypeList="taskTypeList"
                    :taskClassificationTypes="taskClassificationTypes" 
                    :taskGroupId="taskGroupData.id"
                    :styleB="true" 
                    :taskNumber ="lastIndex"/>

    <quiz-sidebar :isSidebarActive="quizSidebar"
                    :nodeSelected="selectedNode"
                    :buttoncaption="caption"
                    :sidebarHeader="sbarHeader"
                    @saveData="dataSaved"
                    @closeSidebar="quizSidebar = false"
                    :courseId="courseId"
                    :gotoList="allGotos"
                    :moduleId="moduleId"
                    :sourceTaskId="sourceTaskId"
                    :taskTypeList="taskTypeList"
                    :taskClassificationTypes="taskClassificationTypes"
                    :taskGroupId="taskGroupData.id"
                    :styleB="true"
                    :taskNumber ="lastIndex" />
      <videoCapture-sidebar :isSidebarActive="videoCaptureSidebar"
                    :nodeSelected="selectedNode"
                    :buttoncaption="caption"
                    :sidebarHeader="sbarHeader"
                    @saveData="dataSaved"
                    @closeSidebar="videoCaptureSidebar = false"
                    :gotoList="allGotos"
                    :courseId="courseId"
                    :moduleId="moduleId"
                    :sourceTaskId="sourceTaskId"
                    :taskTypeList="taskTypeList"
                    :taskClassificationTypes="taskClassificationTypes" 
                    :taskGroupId="taskGroupData.id"
                    :styleB="true"
                    :taskNumber ="lastIndex" />

      <presentation-sidebar :isSidebarActive="presentationSidebar"
                          :nodeSelected="selectedNode"
                          :buttoncaption="caption"
                          :sidebarHeader="sbarHeader"
                          @saveData="dataSaved"
                          @closeSidebar="presentationSidebar = false"
                          :gotoList="allGotos"
                          :courseId="courseId"
                          :moduleId="moduleId"
                          :sourceTaskId="sourceTaskId"
                          :taskTypeList="taskTypeList"
                          :taskGroupId="taskGroupData.id"
                          :taskClassificationTypes="taskClassificationTypes"
                          :styleB="true"    
                          :taskNumber ="lastIndex" />

    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <div class="flex flex-wrap-reverse items-center">
        <div class="p-3 mb-8 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="previewStyleB">
          <feather-icon icon="PlayIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Preview</span>
        </div>

      </div>
      <div class="p-3 mb-8 flex items-center justify-between">
        <vs-button class="school-primary_gradient" :disabled="allTaskForModule.length < 1" radius icon-pack="feather" icon="icon-settings" @click="configure" />
      </div>
    </div>

    <vx-card class="mb-3" ref="OptionalTasks">
      <div class="optionalOptions">
        <vx-card title="Map" class="map">
          <file-pond
                id="filepond"
                ref="pond"
                :server="uploadLocation"
                :label-idle="mapData.uploadedFileDocumentUrl.length == 0 ?  'Drop pdf document here or <span class=filepond--label-action><b>Browse</b></span>' : 'Drop pdf document here or <span class=filepond--label-action><b>Browse</b></span> to replace existing document' "
                :allow-multiple="false"
                accepted-file-types="application/pdf"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="true"
                @processfile="uploadCompleteMap"
                @removefile="fileRemovedMap"
              />
            <div class="" style="text-align:center;" v-if="isMapUploaded">
              <vs-button color="danger" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="removeMap" ref="saveAdditionalDataButton">Remove</vs-button>
            </div>
        </vx-card>
        <vx-card title="Additional Material" class="additionalMaterial">
          <file-pond
                id="filepond"
                ref="pond"
                :server="uploadLocation"
                :label-idle=" additionalMaterialData.uploadedFileDocumentUrl.length == 0 ?  'Drop pdf document here or <span class=filepond--label-action><b>Browse</b></span>' : 'Drop pdf document here or <span class=filepond--label-action><b>Browse</b></span> to replace existing document' "
                :allow-multiple="false"
                accepted-file-types="application/pdf"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="true"
                @processfile="uploadCompleteAdditionalMaterial"
                @removefile="fileRemovedAdditionalMaterial"
              />
          <div class="" style="text-align:center;" v-if="isAdditionalMaterialUploaded">
            <vs-button color="danger" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="removeAdditionalMaterial" ref="saveAdditionalDataButton">Remove</vs-button>
          </div>
        </vx-card>
        <vx-card title="Introduction Video" class="IntroductionVideo">
          <v-select class="w-full style-chooser"
                      placeholder="Search / Select Video"
                      :options="videos"
                      v-model="videoSelectedId" />
        </vx-card>
      </div>
      <div class="" style="text-align:center;">
        <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveAdditionalData" ref="saveAdditionalDataButton">Save</vs-button>
      </div>

    </vx-card>
    <vx-card 
      v-show="!isTaskGroupListHidden"
      title="Task Groups (Modules)">
    <vs-table
      ref="taskGroupTable"
      stripe
      class="vs-con-loading__container"
      single
      @selected="handleSelectedTaskGroup"
      pagination
      :max-items="itemsPerPage"
      search
      :data="taskGroups"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">       
        <div class="p-3 mb-8 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="isTaskGroupListHidden = true">
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-success">Add</span>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 ml-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ taskGroups.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : taskGroups.length }} of {{ taskGroups.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="IntroductionVideo">Introduction Video</vs-th>
        <vs-th sort-key="moduleName">Module</vs-th>
        <vs-th sort-key="moduleDescription">Created On</vs-th>
        <vs-th sort-key="number">Task Group Number</vs-th>
        <vs-th sort-key=""></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">

          <vs-td :data="data[indextr].name">{{ item.name }}</vs-td>

          <vs-td :data="data[indextr].introductionVideoTaskId">{{ item.introductionVideoTaskId ? videos.filter(x=>x.value == item.introductionVideoTaskId)[0].label  : "N/A" }}</vs-td>

          <vs-td :data="data[indextr].moduleName">{{ item.moduleName }}</vs-td>

          <vs-td :data="data[indextr].createdOn">{{ item.createdOn.replace("T", " ").split('.')[0] }}</vs-td>

          <vs-td :data="data[indextr].number">{{ item.number }}</vs-td>


          <vs-td>
            <div class="flex">
              <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="right" icon="icon-arrow-up" :disabled="indextr == 0" @click.stop="moveTaskGroupUp(indextr+1)"></vs-button>
              <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="left" icon="icon-arrow-down" :disabled="indextr == data.length - 1" @click.stop="moveTaskGroupDown(indextr+1)"></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </vx-card>
    <vx-card 
      v-show="isTaskGroupListHidden"
      :title="`${taskGroupData.id ? 'Edit' : 'Add'} Task Group (Module)`">
      <div class="vx-row">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full mb-2">
          <label style="color: black;">Name</label>
          <vs-input id="taskGroupName" autocomplete="off" v-validate="'required'" name="Task Group Name" v-model="taskGroupData.name" class="w-full mb-3"/>
        </div>
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full">
          <label style="color:black;">Video</label>
          <v-select class="w-full style-chooser"
                      placeholder="Search / Select Video"
                      :options="videos"
                      v-model="TaskGroupVideoSelected" 
            />
        </div>  
      </div>
      <vs-table
        ref="taskTable"
        stripe
        class="vs-con-loading__container"
        single
        @selected="handleSelectedTask"
        pagination
        :max-items="itemsPerPage"
        search
        :data="tasksList"
        v-show="taskGroupData.id"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">       
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success">
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-success">Add New Task</span>
            </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="showVideoSidebar">
                  <span>Video</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="showVideoCaptureSidebar">
                  <span>Video Capture</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="showDocumentSidebar">
                  <span>Document</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="showUploadSidebar">
                  <span>Upload</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="showPresentationSidebar">
                  <span>Presentation</span>
                </vs-dropdown-item>
              <vs-dropdown-item @click="showQuizSidebar">
                <span>Quiz</span>
            </vs-dropdown-item>
            
            </vs-dropdown-menu>
          </vs-dropdown>
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 ml-4">
            <div
              class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage2 * itemsPerPage2 - (itemsPerPage2 - 1) }} - {{ tasksList.length - currentPage2 * itemsPerPage2 > 0 ? currentPage2 * itemsPerPage2 : tasksList.length }} of {{ tasksList.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="taskDisplayId">Display Id</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="typeName">Type</vs-th>
          <vs-th sort-key="spesificOutcome">Outcome</vs-th>
          <vs-th sort-key="modifiedOn">Modified On</vs-th>
          <vs-th sort-key="number">Task Number</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
            <vs-td :data="data[indextr].displayId">{{ item.displayId }}</vs-td>
            <vs-td :data="data[indextr].name">{{ item.name }}</vs-td>
            <vs-td :data="data[indextr].typeName">{{ item.typeName }}</vs-td>
            <vs-td :data="data[indextr].spesificOutcome">{{ item.spesificOutcome }}</vs-td>
            <vs-td :data="data[indextr].modifiedOn">{{ item.modifiedOn.replace("T", " ").split('.')[0] }}</vs-td>
            <vs-td :data="data[indextr].number">{{ item.number }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button ref="addTaskGroup" class="mr-2" type="filled" color="success" @click.prevent="addTaskGroup">Save</vs-button>
          <vs-button ref="removeTaskGroup" class="mr-4" color="danger" v-show="taskGroupData.id" @click="removeTaskGroup()">Delete</vs-button>
          <vs-button type="border" color="warning" @click="initValuesTaskGroup">{{ taskGroupData.id ? "Close" : "Cancel" }}</vs-button>
        </div>
      </div>
    </vx-card>

    <vs-popup id="configurePopup" ref="configurePopup" title="Configure Settings for the Module" fullscreen class="popup_class" :active.sync="configurePopupActive">
      <div v-if="configurePopupActive">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <label class="ml-1">Start Task</label>
            <v-select class="w-full style-chooser"
                      placeholder="Search / Select A Start Task"
                      :options="tasks"
                      v-model="startTaskDropdown" />
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-1/2">
            <label class="ml-1">End Task</label>
            <v-select class="w-full style-chooser"
                      placeholder="Search / Select A End Task"
                      :options="tasks"
                      v-model="endTaskDropdown" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-divider></vs-divider>
          </div>
        </div>
        <div v-if="isDigi" class="vx-row pl-4">
          <vx-card ref="completeModuleButton" card-background="#11193f" class="glow-effect_dark fixed-width_languages card__no-padding vs-con-loading__container">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text" style="background-color: #262d4a">
                  <span><feather-icon class="pt-1" icon="CheckIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button  :disabled="!moduleData.startTaskId || moduleData.isModuleComplete"
                          size="large"
                          class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                          style="border-radius:0 7px 7px 0"
                          @click="completeModule">
                {{ moduleData.isModuleComplete ? 'Module Completed' : 'Complete Module' }}
              </vs-button>
            </vx-input-group>
          </vx-card>
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vx-card ref="saveModuleButton" card-background="#11193f" class="glow-effect_dark limit-width_short card__no-padding vs-con-loading__container">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text" style="background-color: #262d4a">
                    <span><feather-icon class="pt-1" icon="SaveIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button  size="large"
                            class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                            style="border-radius:0 7px 7px 0"
                            @click="saveModule">
                  Save
                </vs-button>
              </vx-input-group>
            </vx-card>
          </div>
        </div>
        <div v-else class="vx-row pl-4">
          <vs-button  ref="completeModuleButton"
                      :disabled="!moduleData.startTaskId || moduleData.isModuleComplete"
                      class="vs-con-loading__container"
                      type="filled"
                      color="warning"
                      @click="completeModule">
            {{ moduleData.isModuleComplete ? 'Module Completed' : 'Complete Module' }}
          </vs-button>
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button  ref="saveModuleButton"
                        class="w-full vs-con-loading__container"
                        type="border"
                        color="success"
                        @click="saveModule">
              Save
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/* eslint-disable */
import dialogueSidebar from "./CourseBuilderDialogueForm.vue";
import videoSidebar from "./CourseBuilderVideoForm.vue";
import iSpringQuizSidebar from "./CourseBuilderISpringQuizForm.vue";
import presentationSidebar from "./CourseBuilderPresentationForm.vue";
import documentSidebar from "./CourseBuilderDocumentForm.vue";
import uploadSidebar from "./CourseBuilderUploadForm.vue";
import navigationSidebar from "./CourseBuilderNavigationForm.vue";
import videoCaptureSidebar from "./CourseBuilderVideoCaptureForm.vue";
import quizSidebar from "./CourseBuilderQuizForm.vue";
import textNavigationSidebar from "./CourseBuilderTextNavigationForm.vue";
import podcastSidebar from "./CourseBuilderPodcastForm.vue";
import videoQuizSidebar from "./CourseBuilderVideoQuizForm.vue";
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
import color from "../../assets/utils/color";
import { type } from "os";

import vSelect from 'vue-select'

const config = {
  elements: [],
  autounselectify: true,
  boxSelectionEnabled: false,
  style: [
    {
      selector: 'node',
      style: {
        'height': 80,
        'width': 80,
        'shape': 'data(shape)', //ellipse, triangle, rectangle, round-rectangle, bottom-round-rectangle, cut-rectangle, barrel, rhomboid, diamond, pentagon, hexagon, concave-hexagon, heptagon, octagon, star, tag, vee, polygon "selector": "node[points]", "style": {"shape-polygon-points": "data(points)"}
        'background-fit': 'cover',
        'border-color': '#000',
        'border-width': 2,
        'border-opacity': 0.5,
        'content': 'data(id)',
        'font-size': 'data(fontsize)',
        'color': '#000000', //font color
        'text-valign': 'center',
        'text-halign': 'center',
        'text-outline-width': 1,
        'text-outline-color': '#FFFFFF',
        'text-outline-opacity': 1
      }
    },
    {
      selector: 'edge',
      style: {
        'curve-style': 'bezier',
        'width': 6,
        'target-arrow-shape': 'triangle-backcurve',
        // 'target-arrow-shape': 'tee',
        'line-color': '#FF0000',
        'target-arrow-color': '#FF0000'
      }
    },
  ]
};
export default {
  components: {
    dialogueSidebar,
    videoSidebar,
    iSpringQuizSidebar,
    presentationSidebar,
    documentSidebar,
    uploadSidebar,
    navigationSidebar,
    videoCaptureSidebar,
    quizSidebar,
    textNavigationSidebar,
    podcastSidebar,
    videoQuizSidebar,
    'v-select': vSelect,
    FilePond
  },
  name: "Builder",
  data() {
    return {
      presentationSidebar: false,
      fromStyleB: true,
      moduleData: {
        id: 0,
        courseId: 0,
        name: "",
        description: "",
        coinCount: "",
        milestones: [],
        startTaskId: "",
        endTaskId: "",
        isModuleComplete: false,
        price: 0,
        moduleCategoryId: null,
        moduleGroupId: null
      },
      isTaskGroupListHidden:false,
      taskGroups:[],
      taskGroupData:{
        id:0,
        name:'',
        moduleId:'',
        uploadedFileDocumentUrl:'',
        VideoId:0,
      },
      TaskGroupVideoSelected:0,
      mapData:{
        uploadedFileDocumentUrl:'',
      },
      additionalMaterialData:{
        uploadedFileDocumentUrl:'',
      },
      busy: false,
      isMounted: false,
      itemsPerPage: 6,
      itemsPerPage2: 6,
      tasks: null,
      startTaskDropdown: 0,
      endTaskDropdown:0,
      selectedData: null,
      configurePopupActive: false,
      videoSidebar: false,
      documentSidebar: false,
      quizSidebar:false,
      selectedNode: {},
      caption: "",
      sbarHeader: "",
      config,
      selectedId: 0,
      nodeClickedId: 0,
      allTaskForModule:[],
      tasksList:[],
      allGotos: [],
      moduleId: "",
      courseId: "",
      taskClassificationTypes: [],
      sourceTaskId: 0,
      uploadSidebar: false,
      videoCaptureSidebar: false,
      videos:[],
      videoSelectedId:0,
      taskTypeList: [
        {text:'Video',value:2},
        {text:'Document',value:5},
        {text:'Upload',value:6},
        {text:'Quiz',value:9}
      ],
      additionalMaterialFile:false,
      mapFile:false,
      lastIndex:0,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.taskGroupTable.currentx;
      }
      return 0;
    },
    currentPage2() {
      if (this.isMounted) {
        return this.$refs.taskTable.currentx;
      }
      return 0;
    },
    isDigi: function() {
      if(localStorage.getItem("type") == "digi")
        return true;
      else
        return false;
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    isSaveButtonAvailable(){
      var self = this;
      if(self.videoSelectedId || self.additionalMaterialData.uploadedFileDocumentUrl || self.mapData.uploadedFileDocumentUrl)
      return true;
      else
      return false;
    },
    isAdditionalMaterialUploaded(){
      var self = this;
      if(self.additionalMaterialData.uploadedFileDocumentUrl && !self.additionalMaterialFile){
        return true;
      }
      else
        return false;
    },
    isMapUploaded(){
      var self = this;
      if(self.mapData.uploadedFileDocumentUrl && !self.mapFile){
        return true;
      }
      else
        return false;
    }
  },
  methods: {
    initSidebar(id, taskTypeId) {
      var self = this;
      self.lastIndex =self.tasksList.length != 0 ? self.tasksList[self.tasksList.length-1].number + 1 : 1;
      if (taskTypeId == 2)
        this.videoSidebar = true;
      else if (taskTypeId == 4)
        this.presentationSidebar = true;
      else if (taskTypeId == 5)
        this.documentSidebar = true;
      else if (taskTypeId == 6)
        this.uploadSidebar = true;
      else if(taskTypeId == 9)
        this.quizSidebar = true;
      else if(taskTypeId == 8)
        this.videoCaptureSidebar = true;
      this.selectedNode = {};
      this.caption = "Add";
      this.sbarHeader = "Add Task";

      if(!isNaN(id)){
        this.sourceTaskId = id;
      }
    },
    showVideoCaptureSidebar(){
      this.initSidebar(0, 8);
    },
    showQuizSidebar() {
      this.initSidebar(0, 9);
    },
    showVideoSidebar() {
      this.initSidebar(0, 2);
    },
    showPresentationSidebar() {
      this.initSidebar(0, 4);
    },
    showDocumentSidebar() {
      this.initSidebar(0, 5);
    },
    showUploadSidebar() {
      this.initSidebar(0, 6);
    },
    dataSaved(val, taskTypeId){
      this.videoSidebar = false;
      this.documentSidebar = false;
      this.uploadSidebar = false;
      this.quizSidebar = false;
      this.videoCaptureSidebar =false;
      this.presentationSidebar = false;
      this.getTaskForTaskGroups();
      if(val) {
        this.initSidebar(val, taskTypeId)
      }
    },
    handleSelectedTask(tr) {
      var self = this;
      if (tr.typeName == 'Video') {
        self.videoSidebar = true;
      }else if(tr.typeName == 'Document'){
        self.documentSidebar = true; 
      }
      else if (tr.typeName == 'Upload') {
        self.uploadSidebar = true;
      }
      if (tr.typeName == 'Quiz') {
        self.quizSidebar = true;
      }

      if (tr.typeName == 'Presentation') {
        self.presentationSidebar = true;
      }
      
      if (tr.typeName == 'Video Capture'){
        self.videoCaptureSidebar = true;
      }
      self.caption = "Update";
      self.selectedId = tr.displayId;
      self.nodeClickedId = self.selectedId;
      self.sbarHeader = "Update Task " + self.nodeClickedId;
      self.selectedNode = self.tasksList.filter(function (item) {
          return item.displayId == self.selectedId;
      })[0];
      self.selectedNode.courseId = self.courseId;
    },
    configure() {
      var self = this;

      self.configurePopupActive = true;
      self.tasks = self.allTaskForModule.map((item) => {return {label: item.displayId + " : " + item.name, value: item.id} });
      self.getBuilderModule();
    },
    getBuilderModule(){
      var self = this;
      self.showLoadingOnElement("builderpage", 1, "material");

      var onSuccess = function (response) {
        self.moduleData = response.data;
        if(self.moduleData.startTaskId){
          self.startTaskDropdown = self.tasks.filter(function(item){return item.value == self.moduleData.startTaskId;})[0];
        }
        if (self.moduleData.endTaskId) {
          self.endTaskDropdown = self.tasks.filter(function (item) { return item.value == self.moduleData.endTaskId; })[0];
        }
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.builderpage.$el);
      };

      self.$ajaxGet(self, "module/GetBuilderModule/" + self.moduleId, onSuccess, onFinally);
    },
    loadVideoData() {
      const self = this;

      var onSuccess = function (response) {
        self.videos = [];
        self.videos = response.data.map(item => {return {label:item.text , value:item.value}});
        self.getsaveAdditionalData();
      };

      self.$ajaxGet(self, "video/GetSelectList", onSuccess)
    },
    saveModule() {
      var self = this;

      self.showLoadingOnElement("saveModuleButton", 0.65, "material");
      self.moduleData.startTaskId = self.startTaskDropdown ? parseInt(self.startTaskDropdown.value) : null;
      self.moduleData.endTaskId = self.endTaskDropdown ? parseInt(self.endTaskDropdown.value) : null;

      var onSuccess = response => {
        self.moduleData.id = response.data;
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Module Settings Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
        self.configurePopupActive = false;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.saveModuleButton.$el);
      };
      self.$ajaxPost(self, "module/addeditmodule", self.moduleData, onSuccess, onFinally);
    },
    completeModule() {
      var self = this;
      self.showLoadingOnElement("completeModuleButton", 0.45, "material");

      self.moduleData.startTaskId = self.startTaskDropdown ? parseInt(self.startTaskDropdown.value) : null;
      self.moduleData.endTaskId = self.endTaskDropdown ? parseInt(self.endTaskDropdown.value) : null;
      
      var onSaveSuccess = response => {
        self.moduleData.id = response.data;

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Module Settings Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
          self.configurePopupActive = false;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.completeModuleButton.$el);
        };
        
        self.$ajaxGet(self, "module/CompleteModule/" + self.moduleData.id, onSuccess, onFinally);
      };
      
      var onSaveFinally = function () {
        self.$vs.loading.close(self.$refs.completeModuleButton.$el);
      };
      
      self.$ajaxPost(self, "module/addeditmodule", self.moduleData, onSaveSuccess, onSaveFinally);

    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    gettaskClassificationTypes(){
      var self = this;
      var onSuccess = response => {       
        self.taskClassificationTypes = response.data.map(function(item) {return {value: item.value,label: item.text}})
      };
      self.$ajaxGet(self, "Course/gettaskClassificationTypes", onSuccess);
    },
    getAllTaskOfModule(){
      var self = this;
      var onSuccess = response => {     
        self.allTaskForModule = response.data;
      };
      self.$ajaxGet(self, "TaskGroup/GetAllTaskForModule?moduleId=" + self.moduleId, onSuccess);
    },
    initValuesTaskGroup(){
      this.isTaskGroupListHidden = false;
      this.taskGroupData.uploadedFileDocumentUrl = '';
      this.taskGroupData.name = '';
      this.allTaskForModule = [];
      this.taskGroupData.moduleId = 0;
      this.taskGroupData.id = 0;
      this.tasksList = [];
      this.tasks = null;
      this.endTaskDropdown = 0;
      this.startTaskDropdown = 0;
      this.$validator.errors.clear();
      this.$refs.pond.removeFiles();
      this.getTaskGroups();
      this.getAllTaskOfModule();
    },
    addTaskGroup(){
      var self = this;
      if(self.TaskGroupVideoSelected){
        self.taskGroupData.VideoId = parseInt(self.TaskGroupVideoSelected.value);
      }
      else{
        self.taskGroupData.VideoId = null ;
      }
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("addTaskGroup", 0.45, "material");
          self.taskGroupData.moduleId = localStorage.getItem('currentModule');
          var onSuccess = response => {
            self.$vs.notify({
              title:'Success',
              color: "success",
              text: 'Task Group Saved',
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
            self.initValuesTaskGroup();
          };
          var onFinally = response => {
            self.$vs.loading.close(self.$refs.addTaskGroup.$el);
          }
          self.$ajaxPost(self, "TaskGroup/AddTaskGroup", self.taskGroupData, onSuccess, onFinally);
        }else
        {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    handleSelectedTaskGroup(tr){
      var self = this;
      self.isTaskGroupListHidden = true;
      self.taskGroupData.name = tr.name;
      self.taskGroupData.uploadedFileDocumentUrl = tr.uploadedFileDocumentUrl;
      self.taskGroupData.id = tr.id;
      self.TaskGroupVideoSelected = self.videos.filter(x=>parseInt(x.value) == tr.introductionVideoTaskId);
      self.taskGroupData.VideoTaskId = tr.introductionVideoTaskId ?  parseInt(self.TaskGroupVideoSelected[0].value) : null; 
      self.courseId = tr.courseId.toString();
      self.gettaskClassificationTypes()
      self.getTaskForTaskGroups();
    },
    getTaskGroups(){
      var self = this;
      self.showLoadingOnElement("taskGroupTable", 1, "material");
      var onSuccess = response => {    
        self.taskGroups = response.data;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.taskGroupTable.$el);
      }
      self.$ajaxGet(self, "TaskGroup/GetTaskGroupsList?moduleId=" + self.moduleId, onSuccess, onFinally);
    },
    removeTaskGroup(){
      var self = this;
      self.showLoadingOnElement("removeTaskGroup", 0.45, "material");
      var onSuccess = response => {       
        self.$vs.notify({
          title:'Success',
          color: "success",
          text: 'Task Group Removed',
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
        self.initValuesTaskGroup();
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.removeTaskGroup.$el);
      }
      self.$ajaxGet(self, "TaskGroup/RemoveTaskGroup?moduleId=" + self.moduleId + "&id=" + self.taskGroupData.id, onSuccess, onFinally);
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.taskGroupData.uploadedFileDocumentUrl = response.url;
    },
    uploadCompleteMap(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url){
        this.mapData.uploadedFileDocumentUrl = response.url;
        this.mapFile = true;
      }
    },
    uploadCompleteAdditionalMaterial(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url){
        this.additionalMaterialData.uploadedFileDocumentUrl = response.url;
        this.additionalMaterialFile = true;
      }
        
    },
    fileRemoved(error, file) {
      this.taskGroupData.uploadedFileDocumentUrl = "";
    },
    fileRemovedMap(error, file) {
      this.mapData.uploadedFileDocumentUrl = "";
      this.mapFile = false;
    },
    fileRemovedAdditionalMaterial(error, file) {
      this.additionalMaterialData.uploadedFileDocumentUrl = "";
      this.additionalMaterialFile = false;
    },
    removeMap(){
      this.mapData.uploadedFileDocumentUrl = "";
    },
    removeAdditionalMaterial(){
      this.additionalMaterialData.uploadedFileDocumentUrl = "";
    },
    moveTaskGroupUp(index){
      var self = this;
      self.showLoadingOnElement("taskGroupTable", 1, "material");

      var onSuccess = function (response) {
        self.getTaskGroups();
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.taskGroupTable.$el);
      }
      self.$ajaxGet(self, "TaskGroup/MoveUp?moduleId=" + self.moduleId + "&index=" + index, onSuccess, onFinally);
    },
    moveTaskGroupDown(index){
      var self = this;
      self.showLoadingOnElement("taskGroupTable", 1, "material");

      var onSuccess = function (response) {
        self.getTaskGroups();
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.taskGroupTable.$el);
      }

      self.$ajaxGet(self, "TaskGroup/MoveDown?moduleId=" + self.moduleId + "&index=" + index, onSuccess, onFinally);
    },
    getTaskForTaskGroups(){
      var self = this;
      self.showLoadingOnElement("taskTable", 1, "material");
      var onSuccess = response => {
        self.tasksList = response.data;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.taskTable.$el);
      }
      self.$ajaxGet(self, "TaskGroup/GetTaskForTaskGroup?taskGroupId=" + self.taskGroupData.id, onSuccess, onFinally);
    },
    previewStyleB() {
      let routeData = this.$router.resolve({ name: 'LearningStyleBViewer', query: { moduleId: this.$route.query.moduleId } });
      window.open(routeData.href, '_blank');
    },
    saveAdditionalData(){
      var self = this;
      self.additionalMaterialFile
      self.showLoadingOnElement("OptionalTasks", 1, "material");
      var dataToSend = {
        moduleId:parseInt(self.moduleId),
        AdditionalMaterialUrl: self.additionalMaterialData.uploadedFileDocumentUrl,
        MapTaskUrl: self.mapData.uploadedFileDocumentUrl,
        VideoTaskId: self.videoSelectedId ? parseInt(self.videoSelectedId.value) : 0
      };

      var onSuccess = response =>{
        self.$vs.notify({
          title:'Success',
          color: "success",
          text: 'Optional Tasks Saved',
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
      };
      var onFinally = response =>{
        self.$vs.loading.close(self.$refs.OptionalTasks.$el);
      };
      self.$ajaxPost(self,'Module/AddAdditionalTasks', dataToSend , onSuccess, onFinally);
    },
    getsaveAdditionalData(){
      var self = this;
      self.showLoadingOnElement("OptionalTasks", 1, "material");
      var onSuccess = response =>{
        self.mapData.uploadedFileDocumentUrl = response.data.mapTaskUrl ? response.data.mapTaskUrl : "";
        self.additionalMaterialData.uploadedFileDocumentUrl = response.data.additionalMaterialUrl ? response.data.additionalMaterialUrl : "";
        self.videoSelectedId = self.videos.filter(x=>x.value == response.data.videoTaskId.toString());
      };
      var onFinally = response =>{
        self.$vs.loading.close(self.$refs.OptionalTasks.$el);
      };

      self.$ajaxGet(self,'Module/GetAdditionalTasks?moduleId='+self.moduleId , onSuccess, onFinally);
    },
  },
  mounted() {
    this.loadVideoData();
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    if(this.$route.path == "/digi/builder")
      this.$store.dispatch("updateTheme", "dark");

    this.moduleId = localStorage.getItem("currentModule");
    
    this.initValuesTaskGroup();
    this.isMounted = true;
    
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  }
};
</script>

<style lang="scss" scoped>
.numberinput{
  background: transparent;
  float: left;
}

div.router-view {
  padding-bottom: 0 !important;
}

#content-area .content-wrapper {
  min-height: calc(100vh - 5.6rem) !important;
}

#holder {
  text-align: start !important;
  width: 100%;
  height: calc(100vw * 0.26);
  /* height: 395px; */
}

@media screen and (min-width: 1900px) {
  #holder {
    width: 100%;
    height: calc(100vw * 0.345) !important;
    /* height: 740px !important; */
  }
}

#container:fullscreen {
  background-color: rgba(255, 255, 255, 0);
}
#container:-webkit-full-screen {
  background-color: rgba(255, 255, 255, 0);
}
#container:-moz-full-screen {
  background-color: rgba(255, 255, 255, 0);
}
</style>

<style lang="scss">
.popup_class .vs-popup {
  // background: rgb(65, 71, 94) !important;
  // color: rgb(202, 202, 202) !important;
  // > header.vs-popup--header {
  //   background: rgb(38, 45, 74) !important;

  //   > div.vs-popup--title > h3 {
  //     color: rgb(255, 255, 255) !important;
  //   }
  // }

  .vs-popup--content {
    height: inherit !important;
  }
}

#milestones-row{
  align-items: flex-end;
}

.vs-textarea {
  border: 1px solid #c2c6dc !important;
}

.optionalOptions{
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  .map{
    margin: 5px 0px;
  }
  .IntroductionVideo{
    margin: 5px 0px;
  }
  .additionalMaterial{
    margin: 5px 10px;
  }
}


@media screen and (max-width:950px){
  .optionalOptions{
    flex-direction: column;
    .additionalMaterial{
      margin: 5px 0px;
    }
  }
}
</style>
